<template>
  <div id="app">
    <v-app>
      <router-view/>
    </v-app>
  </div>
</template>

<script>
export default {
  name: 'app'
}
</script>

<style>
@font-face {
  font-family: "Nexa-Bold";
  src: local("Nexa-Bold"),
   url(./assets/fonts/Nexa/Nexa_Bold.otf) format("truetype");
}

#app {
  font-family: "Nexa-Bold", 'Roboto', 'Material Icons', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.strategio-card-container {
  border-radius: 20px !important;
}
/* .strategio-card-container.stardard>.card__title {
  .py-2
	padding-top: 8px !important;
	padding-bottom: 8px !important;

  .justify-center
	-webkit-box-pack: center;
	-ms-flex-pack: center;
	justify-content: center;

  font-size: 20px;
  font-weight: 500;
} */

.strategio-card-button {
  font-size: 12px !important;
}
.strategio-card-button.prim {
  background-color: #00C3D7 !important;
}

.strategio-dialog-button {
  font-size: 10px !important;
}

.strategio-card-container>div:not(.divisor):not(.card__actions) {
  padding-left: 32px !important;
  padding-right: 32px !important;
}
.strategio-card-container>div.divisor {
  padding-left: 25px !important;
  padding-right: 25px !important;
}

.strategio-speed-dial {
  right: 40px !important;
}

.strategio-speed-dial>button {
  width: 40px;
  height: 40px;
  background-color: #2262C6 !important;
  color: white !important;
}

.strategio-speed-dial>.speed-dial__list {
  background-color: white;
  /* border: 1px solid #c3c3c3; */
  border-radius: 20px;
  margin-bottom: 10px;
  /* animation: expandee .25s !important; */
}
.strategio-speed-dial>.speed-dial__list button {
  background-color: transparent !important;
  box-shadow: none;
}
.strategio-speed-dial>.speed-dial__list button i {
  color: rgb(150, 150, 150) !important;
}

.strategio-speed-dial>.speed-dial__list button:hover i {
  color: #01C0D1 !important;
}

/* No se van a aplicar por que es general, lo cual no es factible*/
/*.tooltip__content {
  background-color: transparent !important;
 box-shadow: none !important;
} */


/* @keyframes expandee {
  from {
    transform: translateX(0px) !important;
  }
  to {
    transform: translateX(10px) !important;
  }
} */

/* Pagination component */
.strategio-pagination-component>li>.pagination__navigation {
  box-shadow: none;
  margin-left: 0px;
  margin-right: 0px;
  background-color: transparent;
}
.strategio-pagination-component>li>.pagination__item {
  height: 18px;
  width: 18px;
  border-radius: 100%;
  font-size: 10px;
  box-shadow: none;
  margin: .1em;
  color: grey;
}

.strategio-pagination-component>li>.pagination__item--active {
  color: white;
}

.strategio-pagination-component.folder>li>.pagination__item--active {
  background-color: #FAB100 !important;
}
.strategio-pagination-component.report>li>.pagination__item--active {
  background-color: #19BAE8 !important;
}

.strategio-pagination-component.logs>li>.pagination__item--active {
  background-color: #00B4C7 !important;
}

/* Table component */
.strategio-table-section {
  width: 100%;
}
.strategio-table-section>.table__overflow {
  border-radius: 10px;
  border: 1px lightgray solid;
  /* border-bottom: none; */
}
.strategio-table-section>.table__overflow tbody>:last-child>.datatable__expand-col {
  border-bottom: none;
}
.strategio-table-section>.table__overflow tbody>:nth-last-child(2):not(.expanded) {
  /* background-color: #19BAE8 !important; */
  border-bottom: none !important;
}
.strategio-table-section tbody>tr>td:not(.datatable__expand-col) {
  height: 30px !important;
}

/* Switch component */
.strategio-switch-control.input-group {
  color: #67B44F !important;
}

/* html.overflow-y-hidden body div#app div#app.application.theme--light div.dialog__content.dialog__content__active div.dialog.dialog--active.dialog--scrollable div.strategio-card-container.standard.card div.card__text.py-2 div.container.px-3.py-0 div.layout.wrap.align-center div.flex.xs12.sm6 div.strategio-switch-control.input-group.input-group--hide-details.input-group--selection-controls.switch.accent--text div.input-group__input div.input-group--selection-controls__container { */
div.strategio-switch-control.input-group:not(.input-group--dirty) .input-group--selection-controls__container {
/* .input-group--selection-controls__container { */
  color: #FE4A4B !important;
}
.strategio-switch-control.input-group:not(.input-group--dirty) .input-group--selection-controls__container>.input-group--selection-controls__toggle {
  opacity: 0.2 !important;
}
.strategio-switch-control.input-group>.input-group__input .input-group--selection-controls__toggle {
  width: 31px !important;
  height: 9px !important;
  left: 2px !important;
  opacity: 0.2 !important;
}
.strategio-switch-control.input-group>.input-group__input .input-group--selection-controls__ripple::after {
  width: 16px !important;
  height: 16px !important;
  box-shadow: none !important;
}

.strategio-switch-control.input-group:not(.input-group--dirty)>.input-group__input .input-group--selection-controls__ripple::after {
  background-color: #FE4A4B !important
}

/* Progress linear component */
.strategio-progress-linear-component .progress-linear__background {
  background-color: #00C3D7 !important;
}
.strategio-progress-linear-component .progress-linear__bar>.progress-linear__bar__indeterminate>div {
  background-color: #00C3D7 !important;
  border-color: #00C3D7 !important;
}
.strategio-titles-windows {
  padding-top:60px; 
  padding-bottom:30px; 
  padding-left:60px;
}
.strategio-bgtemplate-color {
  background-color: #2262c6
}
.strategio-bgmain-view {
  background-color: #F4F4F4
}
.strategio-bgbutton-primary {
  background-color: #2262c6 !important;
  border-color: rgb(34, 98, 198) !important;
}

@import url('https://fonts.googleapis.com/css2?family=Open+Sans:wght@400;500;600;700');
</style>



// WEBPACK FOOTER //
// src/App.vue